import React, { Component } from 'react';
import "./Skills.scss";

export default class Skills extends Component {
    render() {
        return (
            <div className="container px-5 py-5 text-center text-white">
                <h1 className="text-primary m-5">Skills</h1>
                <div id="Skills">
                    <div className="Skillbar">
                        <div id="HTML" className="d-flex flex-row justify-content-between bg-primary">
                            <span>HTML</span>
                            <span>93%</span>
                        </div>
                    </div>
                    <div className="Skillbar">
                        <div id="CSS" className="d-flex flex-row justify-content-between bg-primary">
                            <span>CSS/SCSS</span>
                            <span>64%</span>
                        </div>
                    </div>
                    <div className="Skillbar">
                        <div id="Javascript" className="d-flex flex-row justify-content-between bg-primary">
                            <span>Javascript</span>
                            <span>89%</span>
                        </div>
                    </div>
                    <div className="Skillbar">
                        <div id="Bootstrap" className="d-flex flex-row justify-content-between bg-primary">
                            <span>Bootstrap</span>
                            <span>90%</span>
                        </div>
                    </div>
                    <div className="Skillbar">
                        <div id="React" className="d-flex flex-row justify-content-between bg-primary">
                            <span>React</span>
                            <span>77%</span>
                        </div>
                    </div>
                    <div className="Skillbar">
                        <div id="Redux" className="d-flex flex-row justify-content-between bg-primary">
                            <span>Redux</span>
                            <span>48%</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
